import type { JsonObject } from '@/app-package';
import type { AppointmentDoc } from '@bb/domain/dist/schemas';
import type { AxiosRequestConfig } from 'axios';
import axios from 'axios';

const recordAppointment = async (
  listingId: string,
  appointment: JsonObject<
    Pick<
      AppointmentDoc,
      | 'type'
      | 'listingId'
      | 'notify'
      | 'recordAppointment'
      | 'note'
      | 'date'
      | 'time'
      | 'timeEnd'
      | 'buyers'
    > &
      (
        | { coop: AppointmentDoc['coop'] }
        | {
            coop: Record<string, never>;
            customContact: AppointmentDoc['customContact'];
          }
      )
  >,
) => {
  const config: AxiosRequestConfig = {
    url: `/listing/${listingId}/appointments/record`,
    method: 'post',
    data: appointment,
  };

  const { data } = await axios.request<JsonObject<AppointmentDoc>>(config);
  return data;
};

export default recordAppointment;
